// Type definitions for transcription formats

export interface WhisperTranscription {
  task: string;
  language: string;
  duration: number;
  text: string;
  words: { word: string; start: number; end: number }[];
}

export interface TranscribeTranscription {
  jobName: string;
  accountId: string;
  status: string;
  results: {
    transcripts: { transcript: string }[];
    speaker_labels: {
      segments: Array<{
        start_time: string;
        end_time: string;
        speaker_label: string;
        items: Array<{
          speaker_label: string;
          start_time: string;
          end_time: string;
        }>;
      }>;
      channel_label: string;
      speakers: number;
    };
    items: Array<{
      id: number;
      type: string;
      alternatives: Array<{
        confidence: string;
        content: string;
      }>;
      start_time?: string;
      end_time?: string;
    }>;
    audio_segments?: Array<{
      id: number;
      transcript: string;
      start_time: string;
      end_time: string;
      speaker_label: string;
      items: number[];
    }>;
  };
}

// Type guard to check if transcription is OpenAI Whisper format
export const isWhisperFormat = (data: any): data is WhisperTranscription => {
  return data && "words" in data && "text" in data && "task" in data;
};

// Type guard to check if transcription is Amazon Transcribe format
export const isTranscribeFormat = (data: any): data is TranscribeTranscription => {
  return data && "results" in data && "jobName" in data;
};
